/** Customer role names minted by the customer API (`apps/wf-coe-app-api/src/lib/roles.ts`). */
export const CUSTOMER_ADMIN = 'customer-admin';

/** Workfront System Administrators of the license get `customer-admin` (V-02). */
export function isCustomerAdmin(session: { roles: readonly string[] } | null): boolean {
  return session?.roles.includes(CUSTOMER_ADMIN) ?? false;
}
